<template>
  <div
    ref="cerElement"
    class="form-certification"
  >
    <c-legend />
    <edit-table
      :option="option"
      :data="formatData"
      :form.sync="form"
      :loading="loading"
      @submit-add="handleSubmit"
      @submit-edit="handleUpdate"
      @refresh-change="refreshChange"
      @rowDel="handleRowDel"
    >
      <template
        slot="row-details"
        slot-scope="{row}"
      >
        <div style="display:flex;justify-content: space-between;margin-right:200px;">
          <span
            v-for="(item, i) in option.columns"
            :key="i"
          >
            {{ updateAuditData[row.item.id][(item.dictField ? item.dictField : item.field)] }}
          </span>
        </div>
      </template>
    </edit-table>
  </div>
</template>
<script>
import EditTable from '@/components/editTable/index.vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { certification, infoAudit } from '@/api/staff/index'
import { deepClone } from '@/util/util'
import CLegend from './components/legend.vue'
import getColumn from './option/infoCerts'

export default {
  components: {
    EditTable,
    CLegend,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    staffId: {
      type: String,
      default: '',
    },
    auditData: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    currentTab: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      // data: [
      //   {
      //     certName: 'Activity Tracker',
      //     certType: 'Fitness',
      //     certFiles: [{ attachId: '123', originalName: 'zhangsan', link: '123' }],
      //   },
      //   {
      //     certName: 'Activity Tracker2',
      //     certType: 'Fitness2',
      //     certFiles: [{ attachId: '123', originalName: 'zhangsan', link: '123' }],
      //   },
      // ],
      redata: [],
      formatData: [],
      loading: false,
      // 需要number转string的类型
      hasToStringTypes: ['select'],
      updateAuditData: {},
    }
  },
  computed: {
    option() {
      const option = {
        menu: !this.disabled,
        addBtn: !this.disabled,
        columns: getColumn(),
      }
      return option
    },
    // formatData() {
    //   const res = []
    //   const redata = deepClone(this.redata)
    //   const kkk = '_rowVariant';
    //   if (Array.isArray(this.reauditData)) {
    //     this.reauditData.forEach(e => {
    //       const newData = (e.newDataName || e.newData) || (e.oldDataName || e.oldData)
    //       if (newData) {
    //         const item = JSON.parse(newData)
    //         item.option_viewBtn = true
    //         item.option_editBtn = true
    //         item.option_delBtn = true
    //         if (e.action === 'update') {
    //           const find = redata.find(o => o.id === item.id) || {}
    //           find[kkk] = 'warning'
    //           find.option_viewBtn = true
    //           find.option_editBtn = true
    //           find.option_delBtn = true
    //           find.option_detailBtn = true
    //           this.updateAuditData[item.id] = item
    //           return
    //         }
    //         if (e.action === 'save') {
    //           item[kkk] = 'success'
    //         } else if (e.action === 'remove') {
    //           const find = redata.find(o => o.id === item.id) || {}
    //           find[kkk] = 'danger'
    //           find.option_viewBtn = true
    //           find.option_editBtn = true
    //           find.option_delBtn = true
    //           return
    //         }
    //         redata.push(item)
    //       }
    //     })
    //   }
    //   redata.forEach(row => {
    //     const temp = row
    //     this.option.columns.forEach(item => {
    //       const type = item.formOption ? item.formOption.type : 'none'
    //       if (this.hasToStringTypes.indexOf(type) !== -1) {
    //         temp[item.field] = row[item.field] ? row[item.field].toString() : ''
    //       }
    //     });
    //     res.push(temp)
    //   })

    //   return res
    // },
  },
  watch: {
    // currentTab(e) {
    //   if (e === 2) {
    //     this.onLoad()
    //   }
    // },
  },
  mounted() {
    this.redata = this.data
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.formatData = []
          this.onLoad()
        } else {
          console.log('元素不可见');
        }
      });
    });

    observer.observe(this.$refs.cerElement);
  },
  methods: {
    async onLoad() {
      this.loading = true
      const res2 = await infoAudit.getList(1, -1, { staffId: this.staffId, status: 1, module: 'infoCerts' })
      this.reauditData = res2.data.data.records
      const res = await certification.getList(1, -1, { staffId: this.staffId })
      this.redata = res.data.data.records
      this.loading = false
      this.formatData = this.getformatData()
    },
    getformatData() {
      const res = []
      const redata = deepClone(this.redata)
      const kkk = '_rowVariant';
      if (Array.isArray(this.reauditData)) {
        this.reauditData.forEach(e => {
          const newData = (e.newDataName || e.newData) || (e.oldDataName || e.oldData)
          if (newData) {
            const item = JSON.parse(newData)
            item.option_viewBtn = true
            item.option_editBtn = true
            item.option_delBtn = true
            if (e.action === 'update') {
              const find = redata.find(o => o.id === item.id) || {}
              find[kkk] = 'warning'
              find.option_viewBtn = true
              find.option_editBtn = true
              find.option_delBtn = true
              find.option_detailBtn = true
              this.updateAuditData[item.id] = item
              return
            }
            if (e.action === 'save') {
              item[kkk] = 'success'
            } else if (e.action === 'remove') {
              const find = redata.find(o => o.id === item.id) || {}
              find[kkk] = 'danger'
              find.option_viewBtn = true
              find.option_editBtn = true
              find.option_delBtn = true
              return
            }
            redata.push(item)
          }
        })
      }
      redata.forEach(row => {
        const temp = row
        this.option.columns.forEach(item => {
          const type = item.formOption ? item.formOption.type : 'none'
          if (this.hasToStringTypes.indexOf(type) !== -1) {
            temp[item.field] = row[item.field] ? row[item.field].toString() : ''
          }
        });
        res.push(temp)
      })

      return res
    },
    // 国际化
    i18n(param) {
      return this.$t(`_staff.labelCert.${param}`)
    },
    handleSubmit(done, row = {}) {
      const params = row
      params.staffId = this.staffId
      if (Array.isArray(row.attachs)) {
        params.certFiles = row.attachs.map(o => o.attachId).join()
      }
      certification.add(params).then(async () => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
        await this.onLoad()
        done()
      }).catch(err => {
        done()
      });
    },
    handleUpdate(done, row = {}) {
      const params = row
      params.staffId = this.staffId
      if (Array.isArray(row.attachs)) {
        params.certFiles = row.attachs.map(o => o.attachId).join()
      }
      certification.update(params).then(async () => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
        await this.onLoad()
        done()
      }).catch(err => {
        done()
      });
    },
    handleRowDel(done, row) {
      certification.remove(row.id).then(async () => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
        await this.onLoad()
        done()
      }).catch(err => {
        done()
      });
    },
    refreshChange() {
      this.onLoad()
    },
  },
}
</script>
<style lang="scss">
.form-certification {
  &-top {
    text-align: right;
  }

  .table-td {
    text-align: center;
    line-height: 50px;

    &-sm {
      width: 200px;
    }
  }
}
</style>
